// eslint-disable-next-line import/no-extraneous-dependencies
import dayjs, { Dayjs } from "dayjs";

const dayJSToMonthYear = (value: Dayjs | null | undefined | string) =>
  value && dayjs(value)?.isValid() ? dayjs(value).format("YYYY-MM") : null;

export default dayJSToMonthYear;
